import { BannerComponent, BookingComponent } from "../../components";
import Breadcrumb from "./components/Breadcrumb";
import DestinationList from "./components/DestinationList";
import React from "react";
import useFetch from "../../commons/useFetch";
function Destination() {
  const {data : destinations}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/destinations/');
  return (
    <div className="destinative">
      <BannerComponent />
      <BookingComponent />
      <div className="destinationContent">
        <div className="container">
          <Breadcrumb />
          {destinations && (
            <DestinationList destinations={destinations} />
          )}
        </div>
      </div>
    </div>
  );
}
export default Destination;
